"use strict";

module.exports = function hasLength(arr, minLength, maxLength) {
  return arr != null && typeof arr !== "function" && (maxLength === undefined ? minLength ? arr.length >= minLength : arr.length >= 0 : arr.length >= minLength && arr.length <= maxLength);
};